<template>
  <div class="cp-sidebar__main__wrapper">
    <div class="card-container">
      <b-form-group class="cp__form__field form__input mb-0" label-class="cp__form__field__label" label="Card number" label-for="number">
        <img class="left-icon" :src="require(`@/assets/images/${(getCardIcon(cardBrand.toLowerCase()))}.svg`)" alt=""/>
        <b-form-input id="number" type="tel" ref="number" class="form-control w-100"
                      :data-error="(cardErrors.number) ? true : false"
                      placeholder="1234 1234 1234 2378" :maxlength="19"
                      v-model.trim="number" v-cardformat:formatCardNumber>
        </b-form-input>
        <div class="right-icon">
          <img id="safe-and-secure" :src="require('@/assets/images/lock.svg')"/>
          <b-tooltip target="safe-and-secure" triggers="hover" placement="top">
            All payments are Safe and Secure
          </b-tooltip>
        </div>
        <div v-if="cardErrors.number" class="text-danger input-error text-right pr-5">
          <small>{{ cardErrors.number }}</small>
        </div>
      </b-form-group>
      <div class="cp__form__field__wrapper">
        <b-form-group class="cp__form__field form__input mb-0" label-class="cp__form__field__label" label="Expiration" label-for="expiry">
          <b-form-input id="expiry" ref="cardExpInput" class="form-control"
                        :data-error="(cardErrors.expiry) ? true : false" placeholder="MM/YYYY"
                        v-model.trim="expiry" v-cardformat:formatCardExpiry />
          <div v-if="cardErrors.expiry" class="text-danger input-error text-right pr-1">
            <small>{{ cardErrors.expiry }}</small>
          </div>
        </b-form-group>
        <b-form-group class="cp__form__field form__input mb-0" label-class="cp__form__field__label" label="Security code" label-for="expiry_month">
          <b-form-input type="tel" class="form-control" id="cvv_code" ref="cvv_code" :data-error="(cardErrors.cvv_code) ? true : false"
                        placeholder="CVV" pattern="\d*"
                        v-model.trim="cvv_code" v-cardformat:formatCardCVC>
          </b-form-input>
          <div class="right-icon">
            <img id="help" :src="require('@/assets/images/help.svg')"/>
            <b-tooltip target="help" triggers="hover" placement="top">
              3 or 4 Digits usually found on the back of your card
            </b-tooltip>
          </div>
        </b-form-group>
      </div>
    </div>
    <b-form-group class="mb-0" v-if="paymentSource && !paymentSource.isDefault">
      <b-form-checkbox
        id="default"
        v-model="is_default"
        class="billing-information mb-0"
        name="is_default"
        :value="true"
        :unchecked-value="false"
      >
        Set as default Payment Method
      </b-form-checkbox>
    </b-form-group>
    <b-form-group class="mb-0">
      <b-form-checkbox
        id="billShipSame"
        class="billing-information mb-0"
        v-model="billShipSame"
        name="billShipSame"
        :value="true"
        :unchecked-value="false"
      >
        Billing same as shipping information
      </b-form-checkbox>
    </b-form-group>
    <AddressInfo v-if="!billShipSame" />
  </div>
</template>

<script>
import {getHumanReadableDate} from '@/utils'
import {mapState} from 'vuex'
import AddressInfo from '@/components/Order/AddressInfo'

export default {
  name: 'PaymentMethod',
  components: {AddressInfo},
  props: {
    paymentSource: Object
  },
  data: function() {
    return {
      number: null,
      expiry: null,
      cvv_code: null,
      is_default: false,
      cardErrors: {},
      cardBrand: '',
      billShipSame: true,
      errors: {},
      getHumanReadableDate
    }
  },
  computed: {
    ...mapState(['session', 'campaign', 'isLoading']),
    cardBrandClass() {
      return this.getBrandClass(this.cardBrand)
    }
  },
  methods: {
    getBrandClass: function(brand) {
      let cardBrandToClass = {
        'jcb': ['fab', 'cc-jcb'],
        'amex': ['fab', 'cc-amex'],
        'visa': ['fab', 'cc-visa'],
        'unknown': ['fas', 'credit-card'],
        'discover': ['fab', 'cc-discover'],
        'diners': ['fab', 'cc-diners-club'],
        'mastercard': ['fab', 'cc-mastercard']
      }
      brand = cardBrandToClass[brand] ? brand : 'unknown'
      return cardBrandToClass[brand]
    },
    getCardIcon: function(brand) {
      let cardBrandToClass = {
        'jcb': 'jcb',
        'amex': 'amex',
        'visa': 'visa',
        'unknown': 'credit-card',
        'discover': 'discover',
        'diners': 'diners',
        'mastercard': 'mastercard'
      }
      brand = cardBrandToClass[brand] ? brand : 'unknown'
      return cardBrandToClass[brand]
    }
  },
  created() {
    if (this.paymentSource) {
      this.expiry = this.paymentSource.expDate
      this.is_default = this.paymentSource.isDefault
    }
  }
}
</script>

<style scoped>

</style>
